export default __webpack_public_path__ + "static/9-1--2b63ab6b7aa493ccc9f09a84696a4f8c.png";